const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "",
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || "",
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || "",
  // Cognito hosted-UI scopes. Default covers id_token decoding + email.
  cognitoScopes: import.meta.env.VITE_COGNITO_SCOPES || "openid+email+profile",
} as const;

export default config;
